// The glowing icon is yellow when the AI listens, and soft blue when it plays
// someone who needs to vent (Listen mode), so the two chats look different.
export const AI_VENTER_TINT = '[filter:hue-rotate(165deg)_saturate(0.8)]';
